/**
 * Port von `Components/Util/IwmDashboardNavCard.razor`, seit REQ-22 im Look des
 * Entwurfs „IWM Hub Redesign" (Zeilen 540–549): helle Karte mit Symbolkachel,
 * Name der Ansicht und Kategorie als Zusatzzeile.
 */

import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { navIconFor } from '@/components/layout/navIcons';
import type { ChinaAppSysView } from '@/types/entities';
import { buildViewHref } from '@/utils/viewNavigation';

export interface DashboardNavCardProps {
  view: ChinaAppSysView;
  kategorie: string | null;
}

/** Kantenlänge des Entitätssymbols in der Kachel (Entwurf Zeile 542). */
const ICON_SIZE = 19;

export function DashboardNavCard({ view, kategorie }: DashboardNavCardProps): ReactElement {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="iwm-dashboard-nav-card"
      onClick={() => {
        void navigate(buildViewHref(view));
      }}
    >
      <span className="iwm-dashboard-nav-card-icon">
        {navIconFor(view.Entity, { size: ICON_SIZE })}
      </span>
      <span className="iwm-dashboard-nav-card-text">
        <span className="iwm-dashboard-nav-card-title">{view.ViewName}</span>
        {/* Statt der Zeilenzahl des Entwurfs („2.449 Einträge · 312 offen") steht
            hier die Kategorie: Zählerstände gibt es ohne je einen zusätzlichen
            `maxcount`-Aufruf nicht (REQ-22 §2.2). */}
        <span className="iwm-dashboard-nav-card-meta">{kategorie}</span>
      </span>
      {/* Der Pfeil ist eine Zierde der Karte und keines der Entitätssymbole aus
          `navIcons.tsx`; er steht deshalb hier (Entwurf Zeile 548). */}
      <svg
        className="iwm-dashboard-nav-card-chevron"
        aria-hidden="true"
        focusable="false"
        width="15"
        height="15"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="m8 5.5 4.5 4.5L8 14.5"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export default DashboardNavCard;
